import { masterpieceGames } from "@/mocks/erogeData";

export default function Masterpiece() {
  const go = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="masterpiece" className="py-14 md:py-20 px-4 md:px-8 bg-background-100/50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-500 text-sm mb-2">
              <i className="ri-award-line" />
              MASTERPIECE
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 tracking-wide">
              工口游戏神作盘点
            </h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-xl leading-7">
              经得起时间考验、被无数玩家奉为经典的神作。无论你是新人还是老玩家，这些作品都值得专程体验。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {masterpieceGames.map((g) => (
            <article
              key={g.id}
              className="group relative rounded-xl bg-background-200/40 border border-background-200/60 overflow-hidden hover:border-accent-500/40 transition-colors cursor-pointer"
              onClick={() => go("#reviews")}
            >
              <div className="relative w-full h-56 md:h-64 overflow-hidden">
                <img
                  src={g.image}
                  alt={`${g.title} 工口游戏神作盘点封面图`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-background-50/20 to-transparent" />
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium">
                  {g.type}
                </span>
                <span className="absolute bottom-3 left-3 font-heading text-5xl text-accent-400/80 leading-none">
                  {g.rating}
                </span>
              </div>
              <div className="p-4 md:p-5 -mt-8 relative z-10">
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-1">{g.title}</h3>
                <p className="text-xs text-foreground-500 mb-3">{g.category} · {g.year} · {g.studio}</p>
                <p className="text-xs leading-6 text-foreground-600 line-clamp-3">{g.desc}</p>
                <div className="flex flex-wrap gap-1.5 mt-3">
                  {g.tags.map((t) => (
                    <span key={t} className="px-2 py-0.5 rounded-md bg-accent-500/10 text-accent-500 text-[11px]">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}